export const formatDate = (dateValue: string | number | undefined) => {
  if (!dateValue && dateValue !== 0) return "N/A";
  
  let date: Date;
  
  // Handle Unix timestamp (seconds from backend)
  if (typeof dateValue === "number" && dateValue > 100000000) {
    date = new Date(dateValue * 1000);
  } else if (typeof dateValue === "string") {
    date = new Date(dateValue);
  } else {
    return "N/A";
  }
  
  if (isNaN(date.getTime())) return "N/A";
  
  const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "numeric" };
  return date.toLocaleDateString(undefined, options);
};

export const formatTZS = (amount: number) => {
  return new Intl.NumberFormat("en-TZ", {
    style: "currency",
    currency: "TZS",
    minimumFractionDigits: 0,
  }).format(amount);
};
